export default {
    namespaced:true,
    state: {
        userInfo:{
            account: '',
            avatar: '',
            deptId: '',
            email: '',
            id: '',
            name: '',
            phone: '',
            companyName:'',
            companyAddress:'',
            legalName:'',
            legalRepPhone:'',
            legalIdCard:'',
            mail:'',
            creditCode:''
        },
        isMaster:'', //是否主体库 0 不是 1 是
        loginState: 0,
        oauthId:''
    },
    getters:{
        getAccount( state ){
            return  state.userInfo.account || localStorage.getItem('state.userInfo.account')
        },
        getAvatar( state ){
            return  state.userInfo.avatar || localStorage.getItem('state.userInfo.avatar')
        },
        getDeptId( state ){
            return  state.userInfo.deptId || localStorage.getItem('state.userInfo.deptId')
        },
        getEmail( state ){
            return  state.userInfo.email || localStorage.getItem('state.userInfo.email')
        },
        getId( state ){
            return  state.userInfo.id || localStorage.getItem('state.userInfo.id')
        },
        getName( state ){
            return  state.userInfo.name || localStorage.getItem('state.userInfo.name')
        },
        getPhone( state ){
            return  state.userInfo.phone || localStorage.getItem('state.userInfo.phone')
        },
        getCompanyName( state ){
            return  state.userInfo.companyName || localStorage.getItem('state.userInfo.companyName')
        },
        getCompanyAddress( state ){
            return  state.userInfo.companyAddress || localStorage.getItem('state.userInfo.companyAddress')
        },
        getLegalName( state ){
            return  state.userInfo.legalName || localStorage.getItem('state.userInfo.legalName')
        },
        getLegalRepPhone( state ){
            return  state.userInfo.legalRepPhone || localStorage.getItem('state.userInfo.legalRepPhone')
        }, 
        getLegalIdCard( state ){
            return  state.userInfo.legalIdCard || localStorage.getItem('state.userInfo.legalIdCard')
        }, 
        getMail( state ){
            return  state.userInfo.mail || localStorage.getItem('state.userInfo.mail')
        }, 
        getMaster( state ){
            return state.isMaster || localStorage.getItem('master')
        },
        getLoginState( state ){
            return state.loginState || localStorage.getItem('loginState')
        },
        getOauthId( state ){
            return state.oauthId || localStorage.getItem('oauthId')
        },
        getCreditCode( state ){
            return state.userInfo.creditCode || localStorage.getItem('state.userInfo.creditCode')
        },
        getCertificatesCode( state ){
            return state.userInfo.certificatesCode || localStorage.getItem('state.userInfo.certificatesCode')
        },
        
    },
    mutations: {
        setUser(state,userInfo){
            state.loginState = 1
            localStorage.setItem('loginState',1)
            localStorage.setItem('closeTime',new Date().getTime() + 24*60*60*1000)
            state.userInfo.account = userInfo.user.account
            localStorage.setItem('state.userInfo.account',userInfo.user.account)
            state.userInfo.avatar = userInfo.user.avatar
            localStorage.setItem('state.userInfo.avatar',userInfo.user.avatar)
            state.userInfo.deptId = userInfo.user.deptId
            localStorage.setItem('state.userInfo.deptId',userInfo.user.deptId)
            state.userInfo.email = userInfo.user.email
            localStorage.setItem('state.userInfo.email',userInfo.user.account)
            state.userInfo.id = userInfo.user.id
            localStorage.setItem('state.userInfo.id',userInfo.user.id)
            state.userInfo.name = userInfo.user.name
            localStorage.setItem('state.userInfo.name',userInfo.user.name)
            state.userInfo.phone = userInfo.user.phone
            localStorage.setItem('state.userInfo.phone',userInfo.user.phone)
            if(userInfo && userInfo.dept){
                state.userInfo.companyName = userInfo.dept.deptName
                localStorage.setItem('state.userInfo.companyName',userInfo.dept.deptName)
                state.userInfo.companyAddress = userInfo.dept.companyAddress
                localStorage.setItem('state.userInfo.companyAddress',userInfo.dept.address)
                state.userInfo.legalName = userInfo.dept.legalName
                localStorage.setItem('state.userInfo.legalName',userInfo.dept.legalName)
                state.userInfo.legalRepPhone = userInfo.dept.legalRepPhone
                localStorage.setItem('state.userInfo.legalRepPhone',userInfo.dept.legalRepPhone)
                state.userInfo.legalIdCard = userInfo.dept.legalIdCard
                localStorage.setItem('state.userInfo.legalIdCard',userInfo.dept.legalIdCard)
                state.userInfo.mail = userInfo.dept.mail
                localStorage.setItem('state.userInfo.mail',userInfo.dept.mail)
                state.userInfo.creditCode = userInfo.dept.creditCode
                localStorage.setItem('state.userInfo.creditCode',state.userInfo.creditCode)
                state.userInfo.certificatesCode = userInfo.dept.certificatesCode
                localStorage.setItem('state.userInfo.certificatesCode',state.userInfo.certificatesCode)
            }
            state.oauthId = userInfo.oauthId
            localStorage.setItem('oauthId',userInfo.oauthId)
        },
        setMaster(state,isMaster){
           state.isMaster = isMaster
           localStorage.setItem('master',isMaster)
        },
        logout(state){
            localStorage.clear()
            state.userInfo.account = ""
            state.userInfo.avatar = ""
            state.userInfo.deptId = ""
            state.userInfo.email = ""
            state.userInfo.id = ""
            state.userInfo.name = ""
            state.userInfo.phone = ""
            state.userInfo.companyName = ""
            state.userInfo.companyAddress = ""
            state.userInfo.legalName = ""
            state.userInfo.legalRepPhone = ""
            state.userInfo.legalIdCard = ""
            state.userInfo.mail = ""
            let user = JSON.parse(JSON.stringify(state.userInfo));
            state.userInfo = user
        }
    },
    actions: {
        setUser(context,user){
            context.commit('setUser', user)
        },
        setDept(context,dept){
            context.commit('setDept',dept)
        },
        setMaster(context,isMaster){
            context.commit('setMaster',isMaster)
        },
        logout(context) {
            context.commit('logout')
        }
    },
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js